export default __webpack_public_path__ + "static/media/q24_step4.ad874cb2.png";